<template>
  <div class="archivesSensor">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>年次レポート / {{ year }} 年 / 水位</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-area">
        <span class="btn-submit" @click="excelDownload">Excelダウンロード</span>
    </div>
    <div class="section">
      <div class="container">
        <table class="stripe">
          <tr>
            <th class="text-no">#</th>
            <th class="text-tagno">センサー製品ID</th>
            <th>センサー名</th>
            <th class="text-date">測定日時</th>
            <th class="text-water">水位(cm)</th>
            <th class="text-temp">水温(℃)</th>
          </tr>
          <tr v-for="(row, index) in sensorData" :key="index">
            <td class="text-centered">{{ index + 1 }}</td>
            <td class="text-centered">{{ row.sensor_id }}</td>
            <td>{{ row.sensor_name }}</td>
            <td class="text-centered">{{ row.datetime }}</td>
            <td class="text-centered">{{ row.water_level }}</td>
            <td class="text-centered">{{ row.water_temperature }}</td>
          </tr>
          <tr v-if="sensorData.length < sensorAllData.length">
            <td colspan="6" class="list-message" @click="onClickAllItem">
              <span> すべてを見る </span>
            </td>
          </tr>
          <tr v-if="sensorAllData.length === 0">
            <td colspan="6" class="no-message">
              <span> 連係されてる水位データがありません </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import Loader from "@/mixins/loader";

const LIST_COUNT = 10;

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      year: null,
      sensorData: [],
      sensorAllData: [],
      // allChecked: false,
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.createData();
      this.year = await this.getCurrentYear();
    });
  },

  methods: {
    ...mapActions(["retrieveSensorDataHistories"]),
    ...mapGetters(["getSensorDataHistories", "getCurrentYear"]),

    /** 年間データダウンロード */
    excelDownload() {
      const histories = this.getSensorDataHistories();
      var ws_data = [
        [
          "#",
          "センサー製品ID",
          "センサー名",
          "測定日時",
          "水位",
          "水温",
        ],
      ];
      for (let i = 0; i < histories.length; i++) {
        const item = histories[i];
        let rowValue = [];
        rowValue.push(i + 1);
        rowValue.push(item.sensor_id);
        rowValue.push(item.sensor_name);
        rowValue.push(this.formatDate(item.datetime, 'YYYY/MM/DD hh:mm'));
        rowValue.push(item.water_level);
        rowValue.push(item.water_temperature);
        ws_data.push(rowValue);
      }

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_sensor_" +
        this.formatDate(dt, 'YYYYMMDDhhmmss') +
        ".xlsx";
      link.click();
    },

    onClickAllItem() {
      const histories = this.getSensorDataHistories();
      this.sensorData = this.sensorData.concat(
        histories.slice(LIST_COUNT)
      );
    },

    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    /** 1年間分のデータを作成 */
    async createData() {
      await this.retrieveSensorDataHistories();
      this.sensorAllData = this.getSensorDataHistories();
      this.sensorAllData.forEach((el) => {
        let tmpDt = el.datetime;
        if (tmpDt) {
          tmpDt = this.formatDate(new Date(tmpDt), "YYYY/MM/DD hh:mm");
        }
        el.datetime = tmpDt;
      });
      this.sensorData = this.sensorAllData.slice(0, LIST_COUNT);
    },

    formatDate(src, format) {
      const date = new Date(src);

      var year_str = date.getFullYear();
      var month_str = date.getMonth() + 1;
      var day_str = date.getDate();
      var hour_str = date.getHours();
      var minute_str = date.getMinutes();
      var second_str = date.getSeconds();

      month_str = ("0" + month_str).slice(-2);
      day_str = ("0" + day_str).slice(-2);
      hour_str = ("0" + hour_str).slice(-2);
      minute_str = ("0" + minute_str).slice(-2);
      second_str = ("0" + second_str).slice(-2);

      var format_str = format;
      format_str = format_str.replace("YYYY", year_str);
      format_str = format_str.replace("MM", month_str);
      format_str = format_str.replace("DD", day_str);
      format_str = format_str.replace("hh", hour_str);
      format_str = format_str.replace("mm", minute_str);
      format_str = format_str.replace("ss", second_str);

      return format_str;
    },

  },
};
</script>

<style lang="scss">
.archivesSensor {

  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }

  .button-area {
    height: calc(100% - 130px);
    position: relative;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 20px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }

  .section {
    overflow: auto;
    width: 80%;
    max-height: calc(100vh - 200px);
    margin-left: auto;
    margin-right: auto;

    .container {
      // margin: 2rem;
      // margin-left: auto;
      // margin-right: auto;
      padding-right: 10px;
      padding-bottom: 10px;
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    table-layout: fixed;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.text-no {
      width: 10%;
      text-align: center;
    }
    &.text-date {
      width: 20%;
    }
    &.text-tagno {
      width: 20%;
    }
    &.text-water {
      width: 10%;
    }
    &.text-temp {
      width: 10%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.text-centered {
      text-align: center;
    }
    &.text-right {
      text-align: right;
    }
    &.text-left {
      text-align: left;
    }
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }

  .list-message {
    text-align: center;
    cursor: pointer;

    span {
      color: var(--col3);
    }
  }
  .no-message {
    text-align: center;

    span {
      color: #555;
    }
  }

  #input input[type="checkbox"] {
    display: none;
  }
  #input input[type="checkbox"] + label:before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center left;
    width: 25px;
    height: 20px;
    background-size: contain;
    vertical-align: middle;
    display: inline-block;
  }
  #input input[type="checkbox"]:checked + label:before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center left;
    width: 25px;
    height: 20px;
    background-size: contain;
    vertical-align: middle;
    display: inline-block;
  }


  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_water.svg") no-repeat center center;
  }
}
</style>
